import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccessService } from '../../service/access.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModErrorComponent } from '../../modals/mod-error/mod-error.component';

export interface DialogData {
  id: number;
  status: any;

}

@Component({
  selector: 'app-modal-terminate',
  templateUrl: './modal-terminate.component.html',
  styleUrls: ['./modal-terminate.component.css']
})
export class ModalTerminateComponent implements OnInit {
  id: number;
  status: any;
  changeStatus= 11;
  observation: string;
  constructor(
    private spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    private dataApi: AccessService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalTerminateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { 
      this.id = data.id; 
      this.status= data.status;
      if(this.status==12){
          this.changeStatus= 13;
      }
    }

  ngOnInit() {
  }

  aceptar() {
    this.spinner.show("modalaccessTerminate");

    const commentary = {
      commentary: this.observation
    }

    this.dataApi.changeTerminate(this.id, this.changeStatus, commentary).subscribe(() => {
      this.spinner.hide("modalaccessTerminate");
      this.dialogRef.close(true);
    }, () => {
      this.spinner.hide("modalaccessTerminate");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });



  }

}
